import React, { Component } from "react";
import Tab from "../elements/Tab";
import "../styles/SelectTabs.css";

class SelectTabs extends Component {
  render() {
    let classes = ["select-tabs"];
    classes = classes.concat(this.props.classes);

    return (
      <div className={classes.join(" ")}>
        {this.props.options.map(option => (
          <Tab
            key={option}
            selected={this.props.selected === option}
            onClicked={() => this.props.onValueChange(option)}
          >
            {option}
          </Tab>
        ))}
      </div>
    );
  }
}
export default SelectTabs;



// WEBPACK FOOTER //
// ./src/components/SelectTabs.js